module.exports = __webpack_public_path__ + "static/media/Purple_Timer@3x.c6137ffc.png";